<div class="x3-message-container" [ngClass]="type">
    <ng-content></ng-content>
</div>